import IngredientsAdding from "./IngredientsAdding";
import common from "../../../common";
import Ingredient from "../Ingredient";
import EggBowl from "../EggBowl";

export default class Primary_Ingredients extends IngredientsAdding{
    constructor() {
        super();
    }

    init(bowlPosition) {
        this._bowlPosition = bowlPosition;
        this.createIngredients();
    }

    update() {
        super.update();
    }

    createIngredients(){
        let offset = 0;
        const numOfIngredients = Object.keys(common.selectedRecipeBuild.mainIngredients).length;

        for (let i = 0; i < numOfIngredients; i++) {

            let selectedIngredient = common.selectedRecipeBuild.mainIngredients[i];

            let emptyTex = selectedIngredient.img === 'ing_eggs_static' ? selectedIngredient.img : selectedIngredient.img.slice(0, -5) + "used";

            const emitterTexture = [];
            const textures = selectedIngredient.emitterTexture;
            for (const i in textures) {
                if (textures.hasOwnProperty(i)) {
                    emitterTexture.push(textures[i]);
                }
            }

            let ingredient = null;

            if(emptyTex === 'ing_eggs_static'){
                ingredient = new EggBowl({
                    shelf: P3.assets.texture(selectedIngredient.img),
                    empty: P3.assets.texture(emptyTex)
                }, {
                    x: 400 + (offset - 100),
                    y: common.getRandomInt(0, -300)
                }, selectedIngredient.emitter, emitterTexture);
            }else{
                ingredient = new Ingredient({
                    shelf: P3.assets.texture(selectedIngredient.img),
                    empty: P3.assets.texture(emptyTex)
                }, {
                    x: 400 + (offset - 100),
                    y: common.getRandomInt(0, -300)
                }, selectedIngredient.emitter, emitterTexture);
            }


            ingredient.id = i;
            ingredient._animIn = this.animateIngredients(ingredient, {x: 400 + offset, y: 300}, 1000, i === numOfIngredients - 1);
            ingredient._respawnPosition = {x: 400 + offset, y: 300};

            this._bindings[i + 'dragStart'] = ingredient.signals.dragStart.add(()=>{
                this._innerContainer.removeChild(ingredient);
                this._innerContainer.addChild(ingredient);
                if(this._tutorialFinger)
                    this._tutorialFinger.turnOff();
            }, this);
            this._bindings[i + 'dragEnd'] = ingredient.signals.dragEnd.add(this.checkIngredientBounds, this);
            this._bindings[i + 'remove'] = ingredient.signals.remove.add(this.removeIngredients, this);

            this._innerContainer.addChild(ingredient);
            this._ingredients.unshift(ingredient);
            this._tutorialPositions.unshift(ingredient._respawnPosition);
            offset += common.STAGE_HEIGHT / numOfIngredients;
        }
        this._ingredientIndex = this._ingredients.length - 1;
        //console.log(this._ingredients);
    }

    removeIngredients(id){
        this._signals.ingredientRemoved.dispatch();
        this._ingredientIndex--;
        let ingCounter = 0;

        for (let i = 0; i < this._ingredients.length; i++) {
            if (this._ingredients[i].id === id) {
                let index = this._tutorialPositions.indexOf(this._ingredients[i]._respawnPosition);
                if (index > -1) {
                    this._tutorialPositions.splice(index, 1);
                   // console.log(this._tutorialPositions);
                }

                const temp = this._ingredients[i];
                temp.floatBackAnimation();
            }
            if(this._ingredients[i]._completed){
                ingCounter++;
            }
        }

        this.createTutorial(false);

        if(ingCounter >= this._ingredients.length) {
            //console.log("Finished");
            this._signals.stageComplete.dispatch();
            P3.audio.playSound("sfx_stage_complete_00");
            this.removeTutorialFinger();
            this._bindings.help.detach();
        }

        let sounds = ['sfx_add_ingredient_00', 'sfx_add_ingredient_01', 'sfx_add_ingredient_02'];
        P3.audio.playSound(common.randomSelection(sounds));
    }
}